import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewOptions } from "@common/types/views/views";
import type { ViewTableInstance } from "@design-system/ViewTable/core/table";
import { useIsTransactionDateLocked } from "./useIsTransactionDateLocked";
import { useViewTableMeta } from "./view/useViewTableMeta";

export const useIsTableReadonly = (table: { options: { meta?: object } }) => {
    const { options: tableOptions } = useViewTableMeta<unknown, ViewOptions>(
        table,
    );

    return tableOptions?.readonly ?? false;
};

export const useIsReadonlyOrLocked = (
    transaction: TransactionListItem,
    table: ViewTableInstance<TransactionListItem>,
) => {
    const isReadonly = useIsTableReadonly(table);
    const isLocked = useIsTransactionDateLocked(transaction);

    return isReadonly || isLocked;
};
